import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) {
        // small delay so it doesn't fight with the initial render
        const t = setTimeout(() => setVisible(true), 400);
        return () => clearTimeout(t);
      }
    } catch (_) {
      setVisible(true);
    }
  }, []);

  const persist = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ value, ts: new Date().toISOString() }));
    } catch (_) { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
      aria-label="Cookie-Hinweis"
      className="fixed inset-x-3 bottom-3 sm:inset-x-auto sm:right-6 sm:bottom-6 z-[60] max-w-md rounded-2xl border border-border/60 bg-white/95 dark:bg-slate-900/95 backdrop-blur-xl shadow-2xl p-4 sm:p-5"
    >
      <div className="flex items-start gap-3">
        <div className="hidden sm:grid place-items-center w-10 h-10 rounded-full bg-amber-100 text-amber-700 shrink-0">
          <Cookie className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-heading font-bold text-sm sm:text-base leading-snug">Wir respektieren deine Privatsphäre</div>
          <p className="text-xs sm:text-sm text-slate-600 dark:text-slate-300 mt-1">
            Dieses Portal verwendet ausschließlich technisch notwendige Cookies (z. B. Login-Session, Sprach- & Theme-Präferenz). Es findet kein Tracking und keine Weitergabe an Dritte statt. Details in unserer{" "}
            <Link to="/legal/privacy" data-testid="cookie-privacy-link" className="text-blue-700 dark:text-blue-400 underline underline-offset-2 hover:text-blue-800">
              Datenschutzerklärung
            </Link>
            .
          </p>
          <div className="flex flex-col-reverse sm:flex-row gap-2 mt-3">
            <Button
              data-testid="cookie-reject-btn"
              variant="ghost"
              size="sm"
              className="sm:mr-auto text-slate-500"
              onClick={() => persist("essential")}
            >
              Nur notwendige
            </Button>
            <Button
              data-testid="cookie-accept-btn"
              size="sm"
              className="rounded-full px-4"
              onClick={() => persist("all")}
            >
              Verstanden
            </Button>
          </div>
        </div>
        <button
          onClick={() => persist("essential")}
          aria-label="Cookie-Banner schließen"
          className="text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 shrink-0"
          data-testid="cookie-close-btn"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
